import { Button, Modal, Text } from "@ttc3k/trekker";
import { Xmark } from "iconoir-react";
import { PropsWithChildren } from "react";
import { css } from "styled-system/css";
import { Box, Flex } from "styled-system/jsx";

type PreviewModalProps = PropsWithChildren & {
  isOpen: boolean;
  onClose: () => void;
  urlText?: string;
};

const headerOptions = [
  { className: css({ borderColor: "border.error", bg: "bg.error.mid" }) },
  {
    className: css({ borderColor: "border.highlight", bg: "bg.highlight.mid" }),
  },
  { className: css({ borderColor: "border.success", bg: "bg.success.mid" }) },
];

export const PreviewModal = ({
  isOpen,
  onClose,
  urlText = "https://whereabouts.tech",
  children,
}: PreviewModalProps) => {
  return (
    <Modal
      open={isOpen}
      placement={"fullPane"}
      onOpenChange={onClose}
      hideCloseTrigger
      portal
    >
      <Flex flexDir="column" w="full" minH="100dvh">
      {/* Header */}
      <Flex
        width={"full"}
        py={"100"}
        px={"250"}
        bg={"bg.lightest"}
        borderBottomWidth={"1px"}
        borderBottomStyle={"solid"}
        borderBottomColor={"border.light"}
        justifyContent={"space-between"}
        alignItems={"center"}
        position={"sticky"}
        top={0}
        zIndex={"toast"}
        flexShrink={0}
      >
        <Flex gap={"75"}>
          {headerOptions.map((op, i) => (
            <Box
              key={i}
              borderRadius={"full"}
              w={"16px"}
              h={"16px"}
              borderWidth={"1px"}
              borderStyle={"solid"}
              className={op.className}
            />
          ))}
        </Flex>
        <Flex
          p={"100"}
          justifyContent={"center"}
          bg={"white"}
          borderRadius={"100"}
          borderColor={"border.light"}
          borderWidth={"1px"}
          borderStyle={"solid"}
          w={{ base: "300px", md: "400px" }}
        >
          <Text color={"text.dark"} lineClamp={1}>
            {urlText}
          </Text>
        </Flex>
        <Button
          visual={"unstyled"}
          Icon={Xmark}
          color={"icon.light"}
          pr={0}
          _hover={{ color: "icon.mid" }}
          css={{ "& svg": { width: "icons.lg", height: "icons.lg" } }}
          onClick={onClose}
        />
      </Flex>

      {/* Content — grows so preview backdrop fills viewport below chrome */}
      <Box bg={"bg.wa.lightest"} flex="1" w="full" minH={0}>
        {children}
      </Box>
      </Flex>
    </Modal>
  );
};
